import { useState } from 'react';
import AskAI from './AskAI';
import { SwitchInput } from '../common/SwitchInput';

export default function AskAIAboutModelsModal({ models }) {
  const [excludeDeleted, setExcludeDeleted] = useState(true);
  const [idFilter, setIdFilter] = useState('');

  let filtered = excludeDeleted ? models.filter(m => !m.toDelete) : models;
  if (idFilter) {
    try {
      const re = new RegExp(idFilter, 'i');
      filtered = filtered.filter(m => re.test(m.idModelo));
    } catch (e) { /* invalid regex, skip filtering */ }
  }

  const lines = filtered.map(m => {
    const globalType = m.typeByCountry?.['*'] || {};
    return `- ${m.idModelo} ${globalType.type && globalType.type !== 'model' ? '(' + globalType.type + ')' : ''}`;
  });
  const prefix = `Here is the complete list of models in our database (${filtered.length} total):\n${lines.join('\n')}\n\n`;

  return (
    <div style={{ maxWidth: '900px', width: '80vw' }}>
      <div className='mb-2 text-muted small d-flex align-items-center flex-wrap'>
        <input
          className='form-control form-control-sm ml-3'
          style={{ width: '180px' }}
          value={idFilter}
          onChange={e => setIdFilter(e.target.value)}
          placeholder='Filter model ids (regex)'
          />
        <SwitchInput className='ml-3' value={excludeDeleted} onChange={setExcludeDeleted}>Exclude deleted</SwitchInput>
      </div>
      <div className='mb-2 ml-1 text-muted small'>Your question will be prefixed with the full list of <strong>{filtered.length}</strong> models from the database.</div>
      <AskAI promptPrefix={prefix} model={'gemini-flash-latest'} placeholder={'Ask a question about the models...'} />
    </div>
  );
}
